<template lang="pug">
.refund-order-container
  .list-items.form
    .item-refund {{ dateTime(change.createdAt) }}
    .item-refund.capitalize {{ change.change }}
    .item-refund.capitalize {{ change.status }}
    .item-refund.pointer(@click="goToChange") Ver
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shExpandButton from '@/components/elements/ExpandButton'
import shNameUser from '@/components/elements/NameUser'
import shInputList from '@/components/elements/InputList'
import router from '@my/router'

export default {
  name: 'Refund',

  components: { shExpandButton, shNameUser, shInputList },

  mixins: [mFilters, mForm],

  props: {
    change: Object
  },

  data () {
    return {
      show: false,
      observations: [],
      observation: ''
    }
  },

  methods: {
    goToChange () {
      this.$store.commit('filterOutside', {
        collection: 'changes',
        search: this.change.change,
        searchBy: 'change'
      })

      router.goToChanges()
    }
  }
}
</script>

<style lang="stylus">
.refund-order-container
  border-bottom 1px solid var(--color-border-items)
  border-radius 1em
  margin-bottom 1em
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Change.vue